module.exports = __webpack_public_path__ + "img/hamburguer-icon.6fe99c81.svg";